import { styled, StyleProps } from "../../styles"
import { flexCss } from "../../Flex"

export interface StyledItemProps {
  disabled?: boolean
  focus?: boolean
}

type Props = StyledItemProps & StyleProps

const StyledItem = styled.div<StyledItemProps>((props: Props) => ({
  ...flexCss,
  padding: props.theme.spacing(3, 6),
  color: props.theme.palette.coal.dark,
  width: `100%`,
  backgroundColor: props.focus ? `hsla(0, 0%, 0%, .05)` : `transparent`,
  borderRadius: props.focus ? 3 : 0,
  opacity: props.disabled ? 0.4 : 1,
}))

StyledItem.defaultProps = {
  disabled: false,
  focus: false,
}

export default StyledItem
